export const mwImage = (url:string) => {
    return url?.split('https://middleware.io/backend/wp-content').join('https://middleware.io/wp-content')
}